import styled from 'styled-components';
import { Text } from '../Typography/Text';
import { tokens } from './tokens';
export const CheckboxLabel = styled(Text) `
  color: ${({ disabled }) => (disabled ? tokens.disabled.color : tokens.normal.color)};
  min-width: 0;
  font-size: ${({ size }) => tokens.CheckboxRoot[size].fontSize};
`;
